import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img29 from "../../About/images/29.png";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import React from "react";

export const Person29 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img29} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Камбарова Жулдуз Думанбековна
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Master of Geoecology
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        {/* No Scopus or ORCID links in this profile */}
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Astana IT University", главный менеджер департамента науки и инноваций
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Менеджер проекта
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Ведение документации по проекту, оформление командировок;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Коммуникация с контролирующими органами, составление писем по согласованию ТЗ и закупок;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Заключение договоров, включая соглашения по коммерциализации технологий.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Специалист с 24-летним стажем в сфере коммерциализации технологий. Имеет опыт маркетинговых исследований, сопровождения договоров по интеллектуальной собственности, консультирования и подготовки документов по технологиям.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимала участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка технологии рискового картирования поражения морской биоты при аварийном разливе нефти на шельфе Каспийского моря. Период реализации: «05» март 2013 г. - «31» декабря 2015 г. Сумма финансирования: US $974 983,85. Заключены три контракта на оказание услуг с ТОО «АзияСофт» и ФБГУ «Каспийский морской научно-исследовательский центр» (Россия) на общую сумму 3 230 000 тенге. Роль – менеджер по коммерциализации.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Изготовление промышленного прототипа ушных бирок для мелкого рогатого скота.  Период реализации: «20» января 2015 г. - «31» июля 2015 г. Сумма финансирования: 73 077 000 тенге. Запущено производство, проведены продажи. Заключен контракт с компанией Service-ICAR S.R.L на оказание услуг по регистрации ушных бирок и ТОО. Ушные бирки прошли оценку. Получены сертификаты на продукцию. Выигран государственный конкурс по закупкам ушных бирок в 2015 году на сумму 729 162 537,6 тенге. Роль – менеджер по коммерциализации.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Обоснование концепции непроточной аккумуляторной батарей Zn/NiOOH. Период реализации: «24» декабря 2014 г. – «30» июня 2015 г. Сумма финансирования: 21 828 840 тенге. Подписано лицензионное соглашение с китайской компанией Tianjin Keyi Jiaxin Technology Co., Ltd. по передаче прав на использование технологии. Роль – менеджер по коммерциализации
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - «Центр компетенций «Электронная промышленность», по грантовой программе «Консорциумы производственного сектора I: Центры компетенций» МЦРИАП РК и Всемирного банка. Сумма финансирования: 275 000 000 тенге. Создана лаборатория прототипирования микропроцессорных электронных плат, общая сумма коммерциализации от основной деятельности составила 22 963 841 тенге. Роль – менеджер проекта.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Ведение проектной и закупочной документации;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Сопровождение договоров и соглашений по коммерциализации;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Переписка с госорганами и партнерами, участие в подготовке отчетности.
                </MyText>
            </Flex>
        </Flex>
    );
}